// src/components/BoardPack/pages/consolidate_boardpack/Financial_Table.jsx
import React, { useEffect, useRef, useState } from "react";
import { useQueue } from "@/context/QueueContext";
import { useNavigate } from "react-router-dom";
import ErrorState from "@/components/common/ErrorStateComponent";
import LoadingComponent from "@/components/common/LoadingComponent";
import { apiCall } from "@/api/apiCall";
import { processParams } from "../../utils/paramsHelper";
import { dynamicKey } from "../../utils/dynamicKey";
import Financial_Table_component from "../../components/consolidate_boardpack_components/Financial_Table_component";

const buildRows = (block) => {
  if (!block?.rows) return [];

  return block.rows.map((r) => ({
    label: r.label,
    contribution1: r.contributionMonth,
    contribution2: r.contributionYtd,
    block1: (r.values || []).slice(0, 4),
    block2: (r.values || []).slice(4, 8),
    ytd1: (r.values || []).slice(8, 12),
    ytd2: (r.values || []).slice(12, 16),
    isGrandTotal: !!r.isGrandTotal,
  }));
};

const Financial_Table = ({ year = "", month = "", contract = "", page = null, isRefresh = false }) => {
  const { enqueue } = useQueue();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [meta, setMeta] = useState(null);
  const hasFetchedRef = useRef(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiParams = processParams(page?.params || {}, { year, month, contract });

      const response = await enqueue(() =>
        apiCall("GET", "/boardpack/consolidate", apiParams, navigate, false, false, isRefresh)
      );

      if (!response?.success) {
        throw new Error(response?.message || "API returned unsuccessful response");
      }

      setTableData(response.data);
      setMeta(response.meta);
    } catch (err) {
      console.error("Financial Table fetch error:", err);
      setError(err.message || "Failed to load data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!year || !month || !contract) return;
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchData();
  }, [year, month, contract]);

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchData} />;
  }

  const ebitda = tableData?.ebitda;
  const netProfit = tableData?.net_profit;

  return (
    <Financial_Table_component
      reportTitle={dynamicKey({ text: page?.title, year, month, contract })}
      sectionTitle={dynamicKey({ text: page?.subtitle, year, month, contract })}
      ebitdaTitle={page?.ebitdaTitle ||`Mawgif Group -SAR'000 - EBITDA`}
      ebitdaRows={buildRows(ebitda)}
      ebitdaHeaderYears={ebitda?.headerYears}
      ebitdaHeaderMonths={ebitda?.headerMonths}
      ebitdaHeaderMeasures={ebitda?.headerMeasures}
      netProfitTitle={page?.netProfitTitle ||`Mawgif Group -SAR'000 - NET PROFIT / (LOSS)`}
      netProfitRows={buildRows(netProfit)}
      netProfitHeaderYears={netProfit?.headerYears}
      netProfitHeaderMonths={netProfit?.headerMonths}
      netProfitHeaderMeasures={netProfit?.headerMeasures}
    />
  );
};

export default Financial_Table;
